module.exports = __webpack_public_path__ + "img/gnu_smart_gallery5.b6923ba5.jpg";